import {ChangeDetectionStrategy, Component, forwardRef, Input, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormArray, UntypedFormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';

import {BaseCtrlValueAccessorFormComponent} from '@sim/form';
import {ClassName} from '@sim/role';

import {MIS} from '@atmi/core/models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MisFormComponent),
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => MisFormComponent),
    },
  ],
  selector: 'app-mis-form',
  styleUrls: ['./mis-form.component.scss'],
  templateUrl: './mis-form.component.html',
})
export class MisFormComponent extends BaseCtrlValueAccessorFormComponent<MIS> implements OnDestroy, OnInit {

  @Input() classNames: ClassName[] = [];

  get misvs() {
    const form = this.form && this.form.controls.MISV as UntypedFormArray;
    return form ? form.controls : [];
  }

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewInit() {

  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  addMISVHandler() {
    if (!this.form || !this.form.controls.MISV) {
      throw new Error('Cannot manage MISV without a control');
    }

    const MISVControl = new UntypedFormControl('');
    (this.form.controls.MISV as UntypedFormArray).push(MISVControl);
  }

  removeMISVHandler(index: number) {
    if (!this.form || !this.form.controls.MISV) {
      throw new Error('Cannot manage MISV without a control');
    }

    (this.form.controls.MISV as UntypedFormArray).removeAt(index);
  }

}
